import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnSearchIcon extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i class="fas fa-search"></i>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-search-icon");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", this.onSearchIconClicked);
        return cell;
    }

    onSearchIconClicked = (ev: MouseEvent) => {
        if (this.table.props.onSearchIconClicked) {
            this.table.props.onSearchIconClicked((ev.currentTarget as HTMLElement).getAttribute("data-id"));
            ev.stopPropagation();
        }
    }

}
